
@switch (navSectionConfig.type) {
  @case (navSectionTypeEnum.NavItems) {
    <gk-nav-items-section
      [navItemsSectionConfig]="navSectionConfig"
      [navbarConfig]="navbarConfig"
    ></gk-nav-items-section>
  }
}
